import { IOption } from '~/ui/components/inputs/Select/types';

const enumToOptions = (enumObj: any): IOption[] =>
  Object.keys(enumObj)
    .filter(enumLabel => !Number.isInteger(+enumLabel))
    .map(enumLabel => ({ value: enumObj[enumLabel], label: enumLabel }));

export default enumToOptions;
